import image1 from '../../images/img-1.jpg'
import image2 from '../../images/img-2.jpg'
import image3 from '../../images/img-3.jpg'
import image4 from '../../images/img-4.jpg'
import image5 from '../../images/img-5.jpg'
import image6 from '../../images/img-6.jpg' 

import sih1 from '../../images/SIH2019/21.JPG'
import sih2 from '../../images/SIH2019/1.JPG'
import sih3 from '../../images/SIH2019/3.jpg'

import smih1 from '../../images/smart india hackathon 2019/1 (1).jpg'
import smih2 from '../../images/smart india hackathon 2019/1 (2).jpg'
import smih3 from '../../images/smart india hackathon 2019/1 (3).jpg'
import smih4 from '../../images/smart india hackathon 2019/1 (4).jpg'
import smih5 from '../../images/smart india hackathon 2019/1 (5).jpg'


const awards = [
    {
      id: 1,
      title: 'SIH 2019 Winner',
      description: 'Singapore India Hackathon 2019 Winner.',
      image: sih1,
      gallery: [sih1, sih2, sih3],
    },
    {
      id: 2,
      title: 'Smart India Hackathon 2019 Winner.',
      description: 'Smart India Hackathon 2019 Winner.',
      image: smih3,
      gallery: [smih1, smih2, smih3, smih4, smih5],
    },
    // {
    //   id: 3,
    //   title: 'Award 3',
    //   description: 'Description of Award 3.',
    //   image: '/images/award3.jpg',
    //   gallery: ['/images/award3_1.jpg', '/images/award3_2.jpg', '/images/award3_3.jpg'],
    // },
    // {
    //   id: 4,
    //   title: 'Award 4',
    //   description: 'Description of Award 4.',
    //   gallery: ['/images/award3_1.jpg', '/images/award3_2.jpg', '/images/award3_3.jpg'],
    // },
    // {
    //   id: 5,
    //   title: 'Award 5',
    //   description: 'Description of Award 5.',
    //   gallery: ['/images/award3_1.jpg', '/images/award3_2.jpg', '/images/award3_3.jpg'],
    // },
    // {
    //   id: 6,
    //   title: 'Award 6',
    //   description: 'Description of Award 6.',
    //   gallery: ['/images/award3_1.jpg', '/images/award3_2.jpg', '/images/award3_3.jpg'],
    // },
  ];

  export default awards;